import { maintenanceApi } from '@/api/maintenance'

class MaintenanceRedirectService {
  constructor() {
    // Don't initialize stores in constructor to avoid Pinia timing issues
  }

  /**
   * Check if maintenance mode is active and redirect if needed
   */
  async checkMaintenanceAndRedirect(router, authStore) {
    try {
      // Check if user is authenticated
      if (!authStore.isAuthenticated) {
        return false
      }

      // Get maintenance status
      const response = await maintenanceApi.getStatus()
      
      const isMaintenanceMode = response.isMaintenanceMode || false
      const isScheduledMaintenance = response.scheduledMaintenance?.isActive || false
      const isScheduledUpcoming = response.scheduledMaintenance?.isUpcoming || false
      
      // If maintenance is active or scheduled maintenance is running
      if (isMaintenanceMode || isScheduledMaintenance) {
        // Check if user is super admin
        const isSuperAdmin = authStore.isSuperAdmin
        
        if (!isSuperAdmin) {
          // Only redirect if not already on maintenance mode page
          if (router.currentRoute.value.path !== '/maintenance-mode') {
            await router.push('/maintenance-mode')
            return true
          }
        }
      } else if (!isScheduledUpcoming) {
        // If maintenance is not active and no upcoming maintenance, redirect from maintenance mode page to dashboard
        if (router.currentRoute.value.path === '/maintenance-mode') {
          await router.push('/dashboard')
          return true
        }
      }
      
      return false
    } catch (error) {
      console.error('Error checking maintenance status:', error)
      return false
    }
  }

  /**
   * Check if scheduled maintenance is currently active
   */
  checkScheduledMaintenance(settings) {
    if (!settings.scheduled_maintenance_enabled || 
        !settings.scheduled_maintenance_start || 
        !settings.scheduled_maintenance_end) {
      return false
    }

    const now = new Date()
    const startTime = new Date(settings.scheduled_maintenance_start)
    const endTime = new Date(settings.scheduled_maintenance_end)
    
    return now >= startTime && now <= endTime
  }

  /**
   * Start periodic maintenance checks
   */
  startPeriodicCheck(router, authStore, intervalMs = 30000) {
    // Check immediately
    this.checkMaintenanceAndRedirect(router, authStore)
    
    // Set up interval
    return setInterval(() => {
      this.checkMaintenanceAndRedirect(router, authStore)
    }, intervalMs)
  }
}

export default new MaintenanceRedirectService()
